import {
  AlertTitle as MuiAlertTitle,
  AlertTitleProps as MuiAlertTitleProps,
  styled,
} from "@mui/material";

const StyledAlertTitle = styled(MuiAlertTitle)(() => {
  return {};
});

interface AlertTitleProps extends MuiAlertTitleProps {
  children: React.ReactNode;
}

export const AlertTitle: React.FC<AlertTitleProps> = ({ children, ...props }) => {
  return <StyledAlertTitle {...props}> {children}</StyledAlertTitle>;
};

export default AlertTitle;
